import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import moment from "moment";
import url from "@/utils/url";
import { api } from "@/utils/api";
import localforage from "localforage";
import NewsHeader from "@/react-components/NewsHeader";
import { openLink } from "@/utils";

import AuthImage from "@/react-components/AuthImage";
import PdfFileItem from "@/react-components/PdfFileItem";
import LoadMore from "@/react-components/LoadMore";
import i18n from "i18next";
import { libraryTypeEnum, reportTypeEnum } from "@/utils/enum";
const { isDisconnected, sitecoreApiHost } = require("@/util");

class PickUp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articles: undefined,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.pickup
      .getList({
        pageIndex: 1,
        pageSize: 3,
      })
      .then((response) => {
        this.setState(
          {
            articles: response.list,
          },
          () => {
            this.getRealPdf();
          }
        );
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  getRealPdf = () => {
    const { articles } = this.state;
    articles.map((item) => {
      const path = item.link.split("key=");
      if (path.length > 1) {
        const key = path[1];
        localforage
          .getItem(key)
          .then((value) => {
            if (value) {
              item.pdfFile = URL.createObjectURL(value);
            } else {
              api.image
                .getByKey({ key })
                .then((response) => {
                  localforage.setItem(key, response).catch((error) => {
                    console.error(error);
                  });
                  item.pdfFile = URL.createObjectURL(response);
                })
                .catch((error) => {
                  console.error("error: " + error.message);
                });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        item.pdfFile = item.link;
      }
    });
  };

  newsClick = (libraryType, link, id, title) => {
    const {
      history: { push },
    } = this.props;
    if (libraryType === libraryTypeEnum.page) {
      push(link);
    } else {
      openLink(link, id, libraryType, title);
    }
  };

  render() {
    const articles = this.state.articles || [];
    return (
      <React.Fragment>
        {articles.length > 0 && (
          <div className="pickup-news-content">
            <NewsHeader
              title={i18n.t("Pickup_Title")}
              subTitle={i18n.t("Pickup_subTitle")}
              to={url.pickup}
            />
            <React.Fragment>
              <div className="pickup-sub-content">
                {articles.map((item, index) => (
                  <div
                    key={index}
                    className={`pickup-news-main-content ${
                      item.libraryType === libraryTypeEnum.pdf
                        ? "pickup-news-main-content-center"
                        : ""
                    }`}
                    onClick={() =>
                      this.newsClick(
                        item.libraryType,
                        item.pdfFile,
                        item.id,
                        item.title
                      )
                    }
                    tabIndex="0"
                  >
                    {item.libraryType === libraryTypeEnum.pdf ? (
                      ""
                    ) : (
                      <div className="pickup-item-img-wrapper">
                        <AuthImage
                          className="pickup-item-img"
                          src={
                            isDisconnected
                              ? `${sitecoreApiHost}${item.cover}`
                              : item.cover
                          }
                          isZoom={false}
                          alt=""
                        />
                      </div>
                    )}
                    <div className="pickup-detail-content">
                      {item.libraryType === libraryTypeEnum.pdf ||
                      item.libraryType === libraryTypeEnum.link ? (
                        <PdfFileItem
                          pdfFile={item.link}
                          pdfTitle={item.title}
                          className={"pick-news-a-link"}
                          itemId={item.id}
                          libraryType={item.libraryType}
                        />
                      ) : (
                        <RouterLink
                          className="pick-news-item-title"
                          to={item.link}
                        >
                          {item.title}
                        </RouterLink>
                      )}
                      {item.catagory && (
                        <div>
                          <span className="pick-news-item-label">
                            {item.catagory}
                          </span>
                        </div>
                      )}
                      <div className="pickup-row-area">
                        <div
                          className={`${
                            item.link.indexOf(reportTypeEnum.research) > -1
                              ? "pickup-research—page-icon"
                              : moment(item.updateDate).isAfter(item.publicDate)
                              ? "pickup-update-icon"
                              : "pickup-publish-icon"
                          }`}
                        ></div>
                        {!(item.link.indexOf(reportTypeEnum.research) > -1) && (
                          <span className="pick-news-item-time">
                            {`${
                              moment(item.updateDate).isAfter(item.publicDate)
                                ? i18n.t("Library_kbn_update")
                                : i18n.t("Library_kbn_publish")
                            }：`}
                          </span>
                        )}
                        <span className="pick-news-item-time">
                          {item.link.indexOf(reportTypeEnum.research) > -1
                            ? item.publicDate?.slice(0, 10)?.replace(/-/g, ".")
                            : moment(item.updateDate).isAfter(item.publicDate)
                            ? item.updateDate?.slice(0, 10)?.replace(/-/g, ".")
                            : item.publicDate?.slice(0, 10)?.replace(/-/g, ".")}
                        </span>
                      </div>
                      <div className="news-item-desc pick-news-item-desc">
                        <div className="news-item-desc-text">
                          {item.summary}
                        </div>
                      </div>
                    </div>
                    <div className="news-pick-item-modal"></div>
                  </div>
                ))}
              </div>
              <LoadMore to={{ pathname: url.pickup }} />
            </React.Fragment>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(PickUp);
